(function($){

    'use strict';

    class HandleNotFound extends HTMLElement {
        constructor() {
            super();
            const shadowRoot = this.attachShadow({ mode: 'open' });
            shadowRoot.innerHTML = `
            <style>
            :host{
            }
            .handle-notfound-content{
                cursor: pointer;
                width: 300px;
                height: 60px;
                line-height: 60px;
                font-size: 14px;
                font-weight: 600;
                color: #FFFFFF;
                text-align: center;
                background: #0074FF;
                border-radius: 16px;
                margin: 40px auto 0px;
                display: none;
            }
            </style>
            <div class="handle-notfound-content" id="handle-notfound-content">
                Jumping to the latest url......
            </div>
            `
            // this.urlPrefix = {
            //     'https://www.makeblock.com/en/docs': 'https://www.makeblock.com/en/docs',
            //     'https://www.makeblock.com/cn/docs': 'https://www.makeblock.com/cn/docs',
            //     'http://127.0.0.1:9292/cn/docs/cyberpi/cyberos': 'https://www.makeblock.com/cn/docs'
            // }
            this.urlMap = {
                'https://www.makeblock.com/cn/docs': 'https://www.yuque.com/makeblock-help-center-zh',
                'https://www.makeblock.com/en/docs': 'https://www.yuque.com/makeblock-help-center-en',
                'https://www.makeblock.com/laserbox-video': 'https://www.xtool.com/pages/xtool-p2',
                'https://www.makeblock.com/pages/xtool-laserbox-rotary': 'https://www.xtool.com/pages/xtool-p2',
                'https://www.makeblock.com/products/xtoolcare-extra-care-for-xtool-d1-pro': 'https://www.xtool.com/pages/xtoolcare',
                'https://www.makeblock.com/maker-tools/laserbox': 'https://www.xtool.com/pages/xtool-p2',
                'https://www.makeblock.com/jp/support': 'https://support.makeblock.com/hc/en-us',
                'https://www.makeblock.com/jp/laserbox-video': 'https://www.xtool.com/pages/xtool-p2',
                'https://www.makeblock.com/jp/news-center-jp/281523.html': 'https://www.xtool.com/products/pre-order-xtool-m1-worlds-first-desktop-hybrid-laser-blade-cutting-machine',
                'https://www.makeblock.com/jp/laserbox-specs': 'https://www.xtool.com/pages/xtool-p2',
                'https://www.makeblock.com/jp/laserbox': 'https://www.xtool.com/pages/xtool-p2',
                'https://www.makeblock.com/jp/official-blog/273105.html': 'https://www.xtool.com/pages/gift-making',
                'https://www.makeblock.com/jp/official-blog/267039.html': 'https://www.xtool.com/pages/gift-making',
                // 'https://www.makeblock.com/project/user-makeblock-computer-vision-extension-for-app-inventor': 'https://support.makeblock.com/hc/en-us',
                // 'https://www.makeblock.com/project/tutorial-for-combined-line-following-and-object-avoidance-2': 'https://support.makeblock.com/hc/en-us',
                // 'https://www.makeblock.com/project/support/ps-neuron': 'https://support.makeblock.com/hc/en-us',
                // 'https://www.makeblock.com/project/project/mini-metal-gear-motor-n20-dc-12v': 'https://support.makeblock.com/hc/en-us',
                // 'https://www.makeblock.com/project/project/6p6c-rj25-cable': 'https://support.makeblock.com/hc/en-us',
                // 'https://www.makeblock.com/project/air-pump-motor-dc-12v-370-02pm': 'https://support.makeblock.com/hc/en-us',
                'https://www.makeblock.com/project/support/ps-ranger': 'https://support.makeblock.com/hc/en-us/sections/360001778374-mBot-Ranger',
                // 'https://www.makeblock.com/project/how-to-use-me-encoder-motor-tuning-tool': 'https://support.makeblock.com/hc/en-us',
                // 'https://www.makeblock.com/project/project/me-ir-remote-controller': 'https://support.makeblock.com/hc/en-us',      
                
                'https://www.makeblock.com/support/ps-mtiny': 'https://support.makeblock.com/hc/en-us/articles/4402732695447-Firmware-Update-for-mTiny-Tap-Pen-Controller',
                'https://www.makeblock.com/support/ps-ultimate': 'https://support.makeblock.com/hc/en-us/sections/360001778514-Ultimate-2-0',
                'https://www.makeblock.com/project/use-mbot-with-app-inventor-v-1-9': 'https://support.makeblock.com/hc/en-us/sections/360001828973-mBot',
                'https://www.makeblock.com/project/python-for-megapi': 'https://support.makeblock.com/hc/en-us/articles/12963818051991-About-MegaPi',

                'https://www.makeblock.com/project/megapi-pro-shield-rj25': 'https://support.makeblock.com/hc/en-us/articles/12963818051991-About-MegaPi',
                'https://www.makeblock.com/project/megapi-pro-encoder-dc-motor-driver': 'https://support.makeblock.com/hc/en-us/articles/12963818051991-About-MegaPi',

                'https://www.makeblock.com/project/ultimate2': 'https://support.makeblock.com/hc/en-us/sections/360001778514-Ultimate-2-0',
                'https://www.makeblock.com/support/ps-codeyrocky': 'https://support.makeblock.com/hc/en-us/sections/360001829193-Codey-Rocky',
                'https://www.makeblock.com/project/ranger': 'https://support.makeblock.com/hc/en-us/sections/360001778374-mBot-Ranger',
                'https://www.makeblock.com/project/use-mbot-with-app-inventor': 'https://support.makeblock.com/hc/en-us/sections/360001828973-mBot',
                'https://www.makeblock.com/project/makeblock-orion': 'https://support.makeblock.com/hc/en-us/sections/360001778374-mBot-Ranger',
                'https://www.makeblock.com/project/mcore': 'https://support.makeblock.com/hc/en-us/articles/4412894402967-mCore-Main-Control-Board-of-mBot',
                'https://www.makeblock.com/project/mbot-get-started': 'https://support.makeblock.com/hc/en-us/sections/360001828973-mBot',

                'https://www.makeblock.com/project/mbot': 'https://support.makeblock.com/hc/en-us/sections/360001828973-mBot',
                'https://www.makeblock.com/project/mbot-resource-download': 'https://support.makeblock.com/hc/en-us/sections/360001828973-mBot',
                'https://www.makeblock.com/project/megapi': 'https://support.makeblock.com/hc/en-us/articles/12963818051991-About-MegaPi',
                'https://www.makeblock.com/project/ultimate-robot-kit': 'https://support.makeblock.com/hc/en-us/sections/360001778514-Ultimate-2-0',
                'https://www.makeblock.com/support/ps-mbot': 'https://support.makeblock.com/hc/en-us/sections/360001828973-mBot',
                'https://www.makeblock.com/project/mbot-programming': 'https://support.makeblock.com/hc/en-us/sections/360001828973-mBot',
                'https://www.makeblock.com/support/ps-laserbox': 'https://support.xtool.com/hc/en-us/categories/1500000825761-Laserbox-Startup-Pro-Rotary-',
                // 'https://www.makeblock.com/project/battery-holder-for-6-aa': 'https://support.makeblock.com/hc/en-us/sections/360001828973-mBot',
                'https://www.makeblock.com/collections/maker-tools/products/makeblock-laserbox-smart-desktop-laser-cutter': 'https://store.xtool.com/collections/laserbox',                
            }

            this.noNormalUrl = {
                'https://www.makeblock.com/support/ps-mtiny#firmware': {
                    'CN': 'https://www.yuque.com/makeblock-help-center-zh/mtiny/firmware_update',
                    'Other': 'https://support.makeblock.com/hc/en-us/articles/4402732695447-Update-Firmware-for-mTiny-Tap-Pen-Controller'
                },
            }

            this.countryInfo = {
                'countryName': '',
                'countryISO': '',
                'continentCode': '',
            }
        }

        connectedCallback() {
            const currentUrl = window.location.href;
            const noNormalUrlKeys = Object.keys(this.noNormalUrl);
            
            if (noNormalUrlKeys.includes(currentUrl)) { // EMMM 特殊地址
                this.handleNoNormalUrl();
                return;
            }
            this.init();
        }

        init() {
            //const makeblockBaseUrl = 'https://www.makeblock.com';
            const makeblockCnBaseUrl = 'https://www.makeblock.com.cn';
            //const xtoolBaseUrl = 'https://www.xtool.com';
            const supportBaseUrl = 'https://support.makeblock.com/hc/en-us';
            const currentUrl = window.location.href;
            const urlMapKeys = Object.keys(this.urlMap);
            const pathname = window.location.pathname;
            const origin = window.location.origin;
            
            const isDocsUrl = currentUrl.indexOf('cn/docs') > 0 || currentUrl.indexOf('en/docs') > 0 ? true : false;
            const isCnUrl =  currentUrl.indexOf('/cn') > 0 && currentUrl.indexOf('/docs') < 0 ? true : false;
            const isMostOfSupport = currentUrl.indexOf('/project') > 0 ? true : false;
            if (isCnUrl) { // cn
                this.handleTipsShow();
                setTimeout(() => {
                    window.location.href = `${makeblockCnBaseUrl}${pathname.split('/cn')[1]}`;
                }, 2500);
                return;
            }

            if (isDocsUrl) { // 语雀
                this.handleTipsShow();
                setTimeout(() => {
                    const url = pathname.includes('/en/docs') ? `${this.urlMap[`${origin}/en/docs`]}${pathname.split('/en/docs')[1]}` : `${this.urlMap[`${origin}/cn/docs`]}${pathname.split('/cn/docs')[1]}`;
                    window.location.href = url;
                }, 2500);
                return;
            }

            if (urlMapKeys.includes(currentUrl)) { // 其他特定
                this.handleTipsShow();
                setTimeout(() => {
                    window.location.href = `${this.urlMap[currentUrl]}`;
                }, 2500);
                return;
            }

            if (isMostOfSupport) { // support
                this.handleTipsShow();
                setTimeout(() => {
                    window.location.href = supportBaseUrl;
                }, 2500);
                return;
            }
            
            this.handleTipsHide();
    
        }

        handleTipsShow() {
            const notfoundContent = this.shadowRoot.getElementById('handle-notfound-content');
            notfoundContent.style.display = 'block';
            notfoundContent.style.marginTop = '200px';
            notfoundContent.style.marginBottom = '200px';
            $('.page-404').hide();
            $('.breadcrumbs').hide();
        }

        handleTipsHide() {
            $('.page-404').show();
            $('.breadcrumbs').show();
        }
        
        handleNoNormalUrl() {
            // 通过 api 获取当前登录用户 ip & 地区
            fetch(
                "https://dtc.mblock.cc/shopify/ip",
                { method: 'GET' }
            )
            .then(response => response.json())
            .then(response => {
                if (response.code !== 0) {
                    return;
                }
                const { data } = response;
                this.countryInfo.countryName = data.country_name;
                this.countryInfo.countryISO = data.country_iso_code;
                this.countryInfo.continentCode = data.continent_code;
                this.handleTipsShow();      
                const currentUrl = window.location.href;
                setTimeout(() => {
                    if (this.countryInfo.countryISO === 'CN') {
                        const url = this.noNormalUrl[currentUrl]['CN'];
                        window.location.href = url;
                    } else {
                        const url = this.noNormalUrl[currentUrl]['Other'];
                        window.location.href = url;
                    }
                }, 1500);
                return;

            }).catch(err => {
              console.error('err', err);
            })
          }
    }
    
    theme.AssetsLoader.onPageLoaded(function() {
        customElements.define('handle-notfound', HandleNotFound);
    });

})(jQueryTheme);